import React, { Component } from "react";
import { connect } from "react-redux";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { PasswordControl } from "../../controls/PasswordControl";
import { CtrlCollection } from "@yuigoto/ctrl";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import { UiActions } from "state/actions/UiActions";
import {
  IgProfileContainer
} from "./Instagram";
import { Utils } from "utils/Utils";

class PasswordChange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validationMessage: ""
    }

    this.collection = new CtrlCollection();
    for (let i in PasswordControl) {
      this.collection.add(PasswordControl[i]);
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.showValidationMessage = this.showValidationMessage.bind(this);

    this.passwordValidationError = false;
  }

  onSubmit(event) {
    event.preventDefault();

    if (!this.collection.validate()) {
      this.forceUpdate();
    } else if (this.collection.getValue("newPassword") !== this.collection.getValue("newPasswordConfirmation")) {
      this.props.errorAlert("Nova senha e confirmação de senha não são iguais");
      this.collection.invalidate("newPasswordConfirmation", " ");
    } else {
      let { data } = this.props.token;

      this.props.loaderShow();

      ExecuteRequest(
        GlamboxEndpoints.Person.updatePassword,
        this.collection.toObject(),
        "PUT",
        {
          Authorization: data.Authorization
        },
        null,
        (response) => {
          this.props.loaderHide();

          const {
            result,
            statusCode
          } = response

          if (statusCode === 200) {
            this.props.successAlert(result.message);
          } else {
            this.collection.invalidate("oldPassword", " ");

            this.props.errorAlert(
              (result && result.message)
                ? result.message
                : "Não foi possível trocar a sua senha, fofa."
            );
          }
        }
      )
    }
  }

  showValidationMessage() {
    const validationMessage = this.state.validationMessage;
    return validationMessage ? (<h3>{validationMessage}</h3>) : null;
  }

  render() {
    return (
      <div className={"level-2"}>
        <div className={"gb-contentblock p-3 p-lg-4"}>
          <form onSubmit={this.onSubmit}>
            <p><small>* Campo Obrigatório</small></p>

            {this.showValidationMessage()}
            {ControlRenderer.renderCollection(this.collection)}
            <button type={"submit"}
              className={"btn btn-light-lime btn-lg"}>
              Trocar Senha
            </button>
          </form>
        </div>
        {Utils.isGp() === false && <IgProfileContainer instagramInfo={this.props.person.insta} />}
        {/*<InstagramInfo></InstagramInfo>*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    person: state.person.data,
    token: state.token
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loaderHide: () => {
      dispatch(UiActions.loaderHide());
    },
    loaderShow: () => {
      dispatch(UiActions.loaderShow());
    },
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    }
    , errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    }
  }
}

PasswordChange = connect(mapStateToProps, mapDispatchToProps)(PasswordChange);

export { PasswordChange };

